export default "__VITE_ASSET__CXbDFg9e__"